import hotkeys from 'hotkeys-js';

export function registerKeys(key, handler, option) {
  hotkeys(key, option, handler);
}